<template>
<div>
  <div>
    <a-input-search placeholder="search" @search="onSearch" style="float:left;width:30%;margin:5px" />
    <a-button-group > 
      <a-button  @click="onSearch(lastMonthShort)" >{{lastMonth}}月</a-button>
      <a-button  @click="onSearch(currentMonthShort)" style="margin:5px">{{currentMonth}}月</a-button>
      <a-button  @click="onSearch('')">All</a-button>
    </a-button-group>
  </div>
  
  

  <a-table :loading="isLoading" :columns="columns" :dataSource="data" size="middle" :pagination="false" expandRowByClick :expandIconAsCell="false" :expandIconColumnIndex="-1">
    <span slot="status" slot-scope="status">
      <a-tag v-if="status==='confirmed'" color="green"><a-icon type="check"/></a-tag>
      <a-tag v-else-if="status==='rejected'" color="red"><a-icon type="close"/></a-tag>
      <a-tag v-else><a-icon type="question"/></a-tag>
    </span>

    <div slot="actions" slot-scope="text, record" style="margin: 0">
      <p>
      <a-popover title="承認しますか？" trigger="click" v-model="record.confirmpopvisible">
        <div slot="content">
          <a-button size="small" @click="onConfirmOKClicked(record)" type="danger" style="margin-left:5px">OK</a-button>
        </div>
        <!-- <a-button size="small" :disabled="record.disable" shape="circle" icon="check"></a-button> -->
        <a-button size="small" :disabled="record.disable">承認</a-button>
      </a-popover>
      </p>
      <p>
      <a-popover title="拒否しますか？" trigger="click" v-model="record.rejectpopvisible">
        <div slot="content">
          <a-input v-model="record.org.comment" placeholder="理由を入力ください" style="width:100%;text-align:left;margin-bottom:5px" />
          <a-button size="small" @click="onRejectOKClicked(record)" type="danger" style="margin-left:5px">OK</a-button>
        </div>
        <!-- <a-button size="small" :disabled="record.disable" type="danger" shape="circle" icon="close" style="margin-left:0"></a-button> -->
        <a-button size="small" :disabled="record.disable" type="danger">拒否</a-button>
      </a-popover>
      </p>
    </div>
    <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
      <!-- <a-card> -->
         <div style="margin-top:5px">
           <a-input :defaultValue="'No.'+record.org.employee.eid" disabled placeholder="未設定" style="width:28%;" />
           <a-input :defaultValue="record.name" disabled placeholder="未設定" style="width:64%;margin-left:10px" />
         </div>

         <div style="margin-top:5px">
           <a-input :defaultValue="record.status_info" disabled placeholder="未設定" style="width:28%;" />
           <a-input :defaultValue="record.org.comment" disabled placeholder="" style="width:64%;margin-left:10px" />
         </div>
          <a-input :defaultValue="record.workinghours" disabled placeholder="未設定" style="margin-top:5px;width:95%"/>

      <!-- </a-card> -->
    </div>
  </a-table>
</div>
</template>
<script>
const columns = [{
    title: '名前',
    dataIndex: 'name',
    key: 'name'
  },{
    title: '対象月',
    dataIndex: 'targmonth',
    key: 'targmonth'
  },
  {
    title: '対象年',
    dataIndex: 'targyear',
    key: 'targyear'
  },
  {
    title: '勤務時間',
    dataIndex: 'workinghours',
    key: 'price'
  },
  {
    title: '状態',
    dataIndex: 'status',
    key: 'status',
     scopedSlots: {
      customRender: 'status'
    }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: {
      customRender: 'actions'
    }
  },
];
export default {
  name: "test",
  created() {
    let info = this.$store.getters.info
    if (info.permissions.filter(p => p.name === this.$permissions.update.wh_status).length > 0) {
      this.disableActions = false
    }
    var today = new Date();
    this.lastMonth = today.getMonth()
    this.currentYear = today.getFullYear()
    this.currentMonth =  this.lastMonth+1
    if (this.lastMonth == 0){
      this.lastMonth = 12
      this.lastMonthShort = this.currentYear - 1 + "/" + this.lastMonth
    } else {
      if (this.lastMonth < 10) {
        this.lastMonthShort = this.currentYear + "/0" + this.lastMonth
      } else {
        this.lastMonthShort = this.currentYear + "/" + this.lastMonth
      }
    }
    if (this.currentMonth < 10) {
      this.currentMonthShort = this.currentYear + "/0" + this.currentMonth;
    } else {
      this.currentMonthShort = this.currentYear + "/" + this.currentMonth;
    }
    
    
    this.loadData()
  },
  computed: {
    data: {
      get: function() {
        this.tableData.sort((a,b)=>{
            if(a.sortkey!==b.sortkey){
              return b.sortkey-a.sortkey
            }else{
	      return b.org.targmonth.replace("/","") - a.org.targmonth.replace("/","")
              
            }
        })
        if (this.filterword) {
          // return this.tableData.filter(d => (d.org.targmonth && d.org.targmonth.indexOf(this.filterword) !== -1));
          //return this.tableData.filter(d => (d.org.targmonth && d.org.targmonth.indexOf(this.filterword) !== -1) || (d.org.status && d.org.status.indexOf(this.filterword) !== -1) || d.status.indexOf(this.filterword) !== -1);
          return this.tableData.filter(d => ((d.org.targmonth && d.org.targmonth.indexOf(this.filterword) !== -1))||
                                              (d.org.targyear && d.org.targyear.indexOf(this.filterword) !== -1)||
                                              (d.name && d.name.indexOf(this.filterword) !== -1));
        } else {
          return this.tableData
        }
      }
    },
  },
  data() {
    return {
      isLoading: true,
      disableActions: true,
      filterword: "",
      tableData: [],
      columns,
      currentMonth:"",
      lastMonth:"",
      currentYear:"",
      lastMonthShort:"",
      currentMonthShort:""
    }
  },
  methods: {
    loadData() {
      this.isLoading = true
      let token = this.$store.getters.token;
      this.$api.workinghours.query({
        token: token
      }).then(data => {
        let resp = data.data;
        this.isLoading = false;
        this.$logger.d("WorkinghoursControl", "loadData.query", {
          response: resp
        });
        if (resp.error) {
          // this.$notification.error({
          //   message: "エラー:" + resp.error.code,
          //   description: resp.error.description
          // });
          // this.$router.push({
          //   path: "/"
          // });
          this.$error_handler(this,resp.error)
        } else {
          this.tableData = []
          resp.result.workinghours.forEach((wh, i) => {
            let s = (wh.status === "comitted") ? "提出済" : (wh.status === "confirmed") ? "承認済" : (wh.status === "rejected") ? "拒否済" : "未設定";
            let sortkey = (wh.status === "comitted") ? 2 : (wh.status === "confirmed") ? 0 : (wh.status === "rejected") ? 1 : 3;
            let disable = (this.disableActions || (wh.status === "rejected" || wh.status === "confirmed")) ? true : false

            if(wh.employee){
              let name = wh.employee.eid
              let userinfo =wh.employee.user.userinfo
              if(userinfo){
                if(userinfo.lastname) name = userinfo.lastname+" "
                if(userinfo.firstname) name = name+userinfo.firstname
              }
              this.tableData.push({
                key: i,
                name:name,
                targmonth: wh.targmonth,
                workinghours:wh.workinghours+"h",
                status_info: s,
                status: wh.status,
                sortkey:sortkey,
                disable: disable,
                confirmpopvisible: false,
                rejectpopvisible: false,
                org: wh
              })
            }
          })
        }
      }).catch(err => {
        this.$logger.e("WorkinghoursControl", "loadData.queryAll", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
        this.$router.push({
          path: "/"
        });
      });
    },
    update(status,record){
      let token = this.$store.getters.token
      let info = this.$store.getters.info
      this.$api.workinghours.update({
        eid: record.org.employee.eid,
        targmonth: record.org.targmonth,
        workinghours:record.org.workinghours,
        comment: record.org.comment,
        status: status,
        token: token
      }).then(data => {
        let resp = data.data;
        this.$logger.d("WorkinghoursControl", "update", {
          response: resp
        });
        if (resp.error) {
          // this.$notification.error({
          //   message: "エラー:" + resp.error.code,
          //   description: resp.error.description
          // });
          this.$error_handler(this,resp.error)
        } else {
          this.loadData()
        }
      }).catch(err => {
        this.$logger.e("WorkinghoursControl", "update", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
      });
    },
    onSearch(value) {
      console.log('test55: '+ value)
      if(value == ''){
        this.filterword = ''
      }else{
        if(value < 10){
          this.filterword = '/0' + value
        }
        else if(value >=10 && value < 100){
          this.filterword = '/' + value
        } else {
          this.filterword = value;
        }
      }
    },
    onRejectOKClicked(record) {
      console.log(JSON.stringify(record.org));
      record.rejectpopvisible = false
      this.update("rejected",record)
    },
    onConfirmOKClicked(record) {
      record.rejectpopvisible = false
      this.update("confirmed",record)
    },
    onEditClicked(emp) {
      console.log(JSON.stringify(emp));
    }
  }
}
</script>
